export default {
  sumOfTickets: {
    inbox_list: [],
    my_chats_list: []
  }
}
